import request from '@/utils/request'
// 三级省市区
export function getareaLevel3() {
  return request({
    url: '/busi/custom/areas/level3',
    method: 'get',
  })
}
// 获取IP所在省市
export function getProCityByIp() {
  return request({
    url: '/busi/custom/pro-city/by-ip',
    method: 'get',
  })
}
// 获取详情
export function getGoodsdetails(params) {
  return request({
    url: '/retail/goods/details',
    method: 'get',
    params: params
  })
}
// 下单
export function orderNew(data) {
  return request({
    url: '/order/new', 
    method: 'post',
    data: data,
    baseURL: 'https://order.huitongxin.cn/api/'
  })
}
